import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path
      fill="#D0D6CE"
      fillRule="evenodd"
      d="M4.722 7.84a6.5 6.5 0 0 1 12.133-2.528A4.85 4.85 0 1 1 17.183 15H5.6a3.633 3.633 0 0 1-.879-7.16"
      clipRule="evenodd"
    />
    <path
      fill="#4C8BF9"
      fillRule="evenodd"
      d="M15.023 14.34a.75.75 0 0 1 .303 1.017L13.66 18.44a.75.75 0 1 1-1.32-.713l1.667-3.084a.75.75 0 0 1 1.016-.303M17.023 17.34a.75.75 0 0 1 .303 1.017L15.66 21.44a.75.75 0 1 1-1.32-.713l1.667-3.084a.75.75 0 0 1 1.016-.303"
      clipRule="evenodd"
    />
    <path fill="#4C8BF9" d="M9 18a1 1 0 1 1-2 0 1 1 0 0 1 2 0M7 21a1 1 0 1 1-2 0 1 1 0 0 1 2 0M11 21a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
  </>
);

const Weather5Colored = Icon('weather-5-colored', svgContents);

export default Weather5Colored;
